import { useEffect } from "react";
import { scroll2Top } from "../../utils/utils";
import SubscriptionCoverBloc from "../../blocs/subscription/SubscriptionCoverBloc";
import SubscriptionFormBloc from "../../blocs/subscription/SubscriptionFormBloc";


export default function SubscriptionPage() {
    
  useEffect(() => {scroll2Top();}, []);

    return (
        <section className="bg-blanc subscription-page">
            <SubscriptionCoverBloc />
                
            <SubscriptionFormBloc />
           
        </section>
    )

}